import * as React from 'react';
import PropTypes from 'prop-types';
import MuiAlert from '@mui/material/Alert';
import {
    Snackbar,
    Stack
} from '@mui/material';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CustomizedSnackbars(props) {
    const {
        messageType = 'success',
        message = 'Successfully saved!',
    } = props;
    const [open, setOpen] = React.useState(true);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar 
                open={open} 
                autoHideDuration={6000} 
                onClose={handleClose}>
                <Alert 
                    onClose={handleClose} 
                    severity={messageType} 
                >
                    {message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}

CustomizedSnackbars.propTypes = {
    messageType: PropTypes.oneOf([
        'success',
        'error'
    ]),
    message: PropTypes.string,
};

export default CustomizedSnackbars;
